define("shared/components/shared/post/secondary/wrapper", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/utils/constants", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _utils, _component2, _tracking, _emberConcurrency, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    {{did-insert this.didInsertWrapper}}
    {{did-update this.removeSecondary @proposedMultiPostIndex}}
    {{will-destroy this.removeHighPerformerModal}}
  >
    {{#if this.activityOpen}}
      <Shared::Post::Secondary::Activity::Wrapper
        @hasUnsavedChanges={{@hasUnsavedChanges}}
        @post={{@post}}
        @toggleActivityModal={{@toggleActivityModal}}
      />
    {{/if}}
    {{#if this.hashtagSuggestionsOpen}}
      <Shared::Post::Secondary::HashtagSuggestions::Wrapper
        @hasDirtyAttributes={{@hasDirtyAttributes}}
        @isCarouselPost={{@isCarouselPost}}
        @location={{@location}}
        @mediaItem={{@mediaItem}}
        @post={{@post}}
        @postElementId={{@postElementId}}
        @postMediaItems={{@postMediaItems}}
        @socialProfile={{@socialProfile}}
        @toggle={{fn @toggleSecondary this.smartHashtagsModalType @targetLocation}}
      />
    {{/if}}
  
    {{#if this.savedCaptionsOpen}}
      <Shared::Post::Secondary::SavedCaptions::Wrapper
        @exitEditingCaption={{task this.exitEditingCaption}}
        @location={{@location}}
        @mediaItem={{@mediaItem}}
        @post={{@post}}
        @postElementId={{@postElementId}}
        @savedCaptionToEdit={{@savedCaptionToEdit}}
        @setCaptionToEdit={{@setCaptionToEdit}}
        @socialProfile={{@socialProfile}}
        @toggle={{fn @toggleSecondary this.savedCaptionsModalType @targetLocation}}
      />
    {{/if}}
  
    {{#if this.captionWriterOpen}}
      <Shared::Post::Secondary::CaptionWriter
        @location={{@location}}
        @mediaItem={{@mediaItem}}
        @post={{@post}}
        @postElementId={{@postElementId}}
        @socialProfile={{@socialProfile}}
        @toggle={{fn @toggleSecondary this.captionWriterModalType @targetLocation}}
      />
    {{/if}}
  
    {{#if this.highPerformerOpen}}
      <Shared::Post::Secondary::HighPerformer::Wrapper
        @post={{@post}}
        @socialProfile={{@socialProfile}}
        @toggleCopyPostModal={{@toggleCopyPostModal}}
      />
    {{/if}}
  
    {{#if this.publishingMethodSetupOpen}}
      <Shared::Post::Secondary::PublishingMethodSetup::Wrapper
        @isMultiProfilePost={{is-present @posts}}
        @location={{@location}}
        @post={{@post}}
        @postElementId={{@postElementId}}
        @posts={{@posts}}
        @showInstagramAuthStatus={{@showInstagramAuthStatus}}
        @socialProfile={{@socialProfile}}
        @toggle={{fn @toggleSecondary this.publishingMethodSetupModalType @targetLocation}}
      />
    {{/if}}
  </div>
  */
  {
    "id": "3xPDmtrg",
    "block": "[[[11,0],[4,[38,0],[[30,0,[\"didInsertWrapper\"]]],null],[4,[38,1],[[30,0,[\"removeSecondary\"]],[30,1]],null],[4,[38,2],[[30,0,[\"removeHighPerformerModal\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"activityOpen\"]],[[[1,\"    \"],[8,[39,4],null,[[\"@hasUnsavedChanges\",\"@post\",\"@toggleActivityModal\"],[[30,2],[30,3],[30,4]]],null],[1,\"\\n\"]],[]],null],[41,[30,0,[\"hashtagSuggestionsOpen\"]],[[[1,\"    \"],[8,[39,5],null,[[\"@hasDirtyAttributes\",\"@isCarouselPost\",\"@location\",\"@mediaItem\",\"@post\",\"@postElementId\",\"@postMediaItems\",\"@socialProfile\",\"@toggle\"],[[30,5],[30,6],[30,7],[30,8],[30,3],[30,9],[30,10],[30,11],[28,[37,6],[[30,12],[30,0,[\"smartHashtagsModalType\"]],[30,13]],null]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"savedCaptionsOpen\"]],[[[1,\"    \"],[8,[39,7],null,[[\"@exitEditingCaption\",\"@location\",\"@mediaItem\",\"@post\",\"@postElementId\",\"@savedCaptionToEdit\",\"@setCaptionToEdit\",\"@socialProfile\",\"@toggle\"],[[28,[37,8],[[30,0,[\"exitEditingCaption\"]]],null],[30,7],[30,8],[30,3],[30,9],[30,14],[30,15],[30,11],[28,[37,6],[[30,12],[30,0,[\"savedCaptionsModalType\"]],[30,13]],null]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"captionWriterOpen\"]],[[[1,\"    \"],[8,[39,9],null,[[\"@location\",\"@mediaItem\",\"@post\",\"@postElementId\",\"@socialProfile\",\"@toggle\"],[[30,7],[30,8],[30,3],[30,9],[30,11],[28,[37,6],[[30,12],[30,0,[\"captionWriterModalType\"]],[30,13]],null]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"highPerformerOpen\"]],[[[1,\"    \"],[8,[39,10],null,[[\"@post\",\"@socialProfile\",\"@toggleCopyPostModal\"],[[30,3],[30,11],[30,16]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"publishingMethodSetupOpen\"]],[[[1,\"    \"],[8,[39,11],null,[[\"@isMultiProfilePost\",\"@location\",\"@post\",\"@postElementId\",\"@posts\",\"@showInstagramAuthStatus\",\"@socialProfile\",\"@toggle\"],[[28,[37,12],[[30,17]],null],[30,7],[30,3],[30,9],[30,17],[30,18],[30,11],[28,[37,6],[[30,12],[30,0,[\"publishingMethodSetupModalType\"]],[30,13]],null]]],null],[1,\"\\n\"]],[]],null],[13]],[\"@proposedMultiPostIndex\",\"@hasUnsavedChanges\",\"@post\",\"@toggleActivityModal\",\"@hasDirtyAttributes\",\"@isCarouselPost\",\"@location\",\"@mediaItem\",\"@postElementId\",\"@postMediaItems\",\"@socialProfile\",\"@toggleSecondary\",\"@targetLocation\",\"@savedCaptionToEdit\",\"@setCaptionToEdit\",\"@toggleCopyPostModal\",\"@posts\",\"@showInstagramAuthStatus\"],false,[\"did-insert\",\"did-update\",\"will-destroy\",\"if\",\"shared/post/secondary/activity/wrapper\",\"shared/post/secondary/hashtag-suggestions/wrapper\",\"fn\",\"shared/post/secondary/saved-captions/wrapper\",\"task\",\"shared/post/secondary/caption-writer\",\"shared/post/secondary/high-performer/wrapper\",\"shared/post/secondary/publishing-method-setup/wrapper\",\"is-present\"]]",
    "moduleName": "shared/components/shared/post/secondary/wrapper.hbs",
    "isStrictMode": false
  });
  let WrapperComponent = _exports.default = (_class = class WrapperComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "dialogManager", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "secondaryModal", _descriptor4, this);
      _defineProperty(this, "activityModalType", _constants.SECONDARY_MODAL_TYPES.ACTIVITY);
      _defineProperty(this, "smartHashtagsModalType", _constants.SECONDARY_MODAL_TYPES.SMART_HASHTAGS);
      _defineProperty(this, "savedCaptionsModalType", _constants.SECONDARY_MODAL_TYPES.SAVED_CAPTIONS);
      _defineProperty(this, "captionWriterModalType", _constants.SECONDARY_MODAL_TYPES.CAPTION_WRITER);
      _defineProperty(this, "highPerformerModalType", _constants.SECONDARY_MODAL_TYPES.HIGH_PERFORMER);
      _defineProperty(this, "publishingMethodSetupModalType", _constants.SECONDARY_MODAL_TYPES.PUBLISHING_METHOD_SETUP);
      _initializerDefineProperty(this, "multiPostActiveIndex", _descriptor5, this);
      _defineProperty(this, "exitEditingCaption", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const hasUnsavedCaption = (0, _utils.isPresent)(this.args.savedCaptionToEdit?.content) && (this.args.savedCaptionToEdit?.isNew || this.args.savedCaptionToEdit?.hasDirtyAttributes);
          if (hasUnsavedCaption) {
            const didConfirm = yield this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
              description: this.intl.t('shared_phrases.changes_not_saved'),
              confirmButton: this.intl.t('shared_words.leave')
            });
            if (!didConfirm) {
              return;
            }
          }
          this.args.rollbackSavedCaption();
        }
      }), null, "exitEditingCaption", null));
    }
    get activityOpen() {
      return this.secondaryModal.isActivityModalActive(this.args.postElementId);
    }
    get hashtagSuggestionsOpen() {
      return this.secondaryModal.isHashtagSuggestionsModalActive(this.args.postElementId);
    }
    get savedCaptionsOpen() {
      return this.secondaryModal.isSavedCaptionsModalActive(this.args.postElementId);
    }
    get captionWriterOpen() {
      return this.secondaryModal.isCaptionWriterModalActive(this.args.postElementId);
    }
    get highPerformerOpen() {
      return this.secondaryModal.isHighPerformerActive(this.args.postElementId);
    }
    get publishingMethodSetupOpen() {
      return this.secondaryModal.isPublishingMethodSetupModalActive(_constants.SECONDARY_MODAL_TYPES.PUBLISHING_METHOD_SETUP);
    }
    async removeSecondary() {
      try {
        if (this.args.proposedMultiPostIndex !== this.multiPostActiveIndex) {
          if (this.savedCaptionsOpen) {
            await this.exitEditingCaption.perform();
          }
          this.multiPostActiveIndex = this.args.proposedMultiPostIndex;
          // Note: Keep secondaryModal open if it is publishing method setup modal
          if (this.publishingMethodSetupOpen) {
            return;
          }
          return this.secondaryModal.removeModal();
        }
      } catch (error) {
        if (error) {
          this.errors.log(error);
        }
      }
    }
    removeHighPerformerModal() {
      if (this.highPerformerOpen) {
        this.secondaryModal.removeModal();
      }
    }
    didInsertWrapper() {
      if (this.args.post?.isHighPerformingPost) {
        this.args.toggleSecondary(this.highPerformerModalType, this.args.targetLocation);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "secondaryModal", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "multiPostActiveIndex", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return this.args.proposedMultiPostIndex;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "removeSecondary", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeSecondary"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeHighPerformerModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeHighPerformerModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "didInsertWrapper", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "didInsertWrapper"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, WrapperComponent);
});